import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/theme.css';
import { loadConfig } from './config/runtime.js';
import App from './App.jsx';

// Load runtime config (API base URL) before first render.
loadConfig().then(() => {
  createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
